/* global store */
/* global IS_PREVIEW_PAGE TRACKING_URL */
/* eslint no-undef: "error"*/
import {
  AD_EVENT,
  CACHEBUSTER_NAME,
} from 'Tracking/constants/trackingNames';
import {
  getTrackingFromTimeLine,
  getTrackingFromAdMetadata,
  getBaseTrackingFromAdMetadata,
  getBaseTrackingFromClient,
  getTrackingFromClient,
  getOrganisationTracking,
} from 'Tracking/selectors';
import {
  REGEX_FOR_CACHEBUSTER,
  createTrackingPixel,
  cachebusterFunction,
  replaceConsentMacros,
} from 'Tracking/utils';

export const createTrackingString = (tracking, divider, separator) => {
  const filterDisallowedValues = key =>
    tracking[key] === 0 || tracking[key] === false || !!tracking[key];
  return Object.keys(tracking).filter(filterDisallowedValues).map(key =>
    `${key}${divider}${encodeURIComponent(tracking[key])}`).join(separator);
};

export const fireThirdPartyTracking = (trackingString) => {
  const decoder = document.createElement('textarea');
  let adjustedTracking = trackingString.replace(REGEX_FOR_CACHEBUSTER, cachebusterFunction());
  adjustedTracking = replaceConsentMacros(adjustedTracking);
  decoder.innerHTML = adjustedTracking;
  const container = document.createElement('div');
  container.innerHTML = decoder.value;
};

export const fireThirdPartyDeliveryTracking = (element, trackingString) => {
  const decoder = document.createElement('textarea');
  let adjustedTracking = trackingString.replace(REGEX_FOR_CACHEBUSTER, cachebusterFunction());
  adjustedTracking = replaceConsentMacros(adjustedTracking);
  decoder.innerHTML = adjustedTracking;
  const trackingArray = decoder.value.split(',');
  trackingArray.forEach((itm) => {
    element.insertAdjacentHTML('beforeend', itm);
    if (itm.toLowerCase().indexOf('</script>') !== -1) {
      const scriptTags = itm.match(/<script.*?src="(.*?)"/gi);
      scriptTags.forEach((scriptItm) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        const scriptSource = scriptItm.match(/<script.*?src="(.*?)"/i)[1];
        script.src = scriptSource;
        element.appendChild(script);
      });
    }
  });
};

const updatePreviewEventLog = (event) => {
  window.top.document.body.dispatchEvent(
    new CustomEvent('preview-tracking', {
      detail: event,
    }),
  );
};

export const fireBaseTracking = (event, placementId, adId, tagInformation = {}) => {
  const tracking = {
    [AD_EVENT]: event,
    ...getBaseTrackingFromAdMetadata(placementId, adId),
    ...getBaseTrackingFromClient(tagInformation),
  };

  if (IS_PREVIEW_PAGE) {
    updatePreviewEventLog({ name: event, meta: tracking });
    return;
  }

  createTrackingPixel(`${TRACKING_URL}?${createTrackingString(tracking, '=', '&')}`);
};

export const fireTracking = (event, additionalTrackedInfo = {}, target = null) => {
  const state = store.getState();
  const {
    thirdPartyTracking = {},
    trackingConsole = [],
  } = state;

  const thirdPartyTrackingUrls = thirdPartyTracking[event] || [];

  const tracking = {
    [AD_EVENT]: event,
    [CACHEBUSTER_NAME]: cachebusterFunction(),
    ...additionalTrackedInfo,
    ...getTrackingFromTimeLine(state),
    ...getTrackingFromAdMetadata(state),
    ...getTrackingFromClient(state),
    ...getOrganisationTracking(state),
  };

  if (additionalTrackedInfo.st) tracking.st = additionalTrackedInfo.st;

  thirdPartyTrackingUrls.forEach(createTrackingPixel);

  trackingConsole.push(tracking);

  if (IS_PREVIEW_PAGE) {
    updatePreviewEventLog({ name: event, meta: tracking, target: target });
    return;
  }

  createTrackingPixel(`${TRACKING_URL}?${createTrackingString(tracking, '=', '&')}`);
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/index.js